import { render, staticRenderFns } from "./IcdSeeAlso.vue?vue&type=template&id=55b42491&scoped=true&"
import script from "./IcdSeeAlso.vue?vue&type=script&lang=js&"
export * from "./IcdSeeAlso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b42491",
  null
  
)

export default component.exports